import { Injectable } from '@angular/core';
import { HttpClient, HttpEventType,HttpHeaders } from '@angular/common/http';
import { TokenService } from '../../token.service';
import {MainService} from './main.service';
@Injectable({
  providedIn: 'root'
})
export class ApproveService {

  httpUrl;
  constructor(private http: HttpClient, private main: MainService, private token:TokenService) {
    this.httpUrl = this.main.httpUrl + '/profile';
  }

  async getDataForCertificate(obj:any){
    const res = await this.http.get<any>(this.main.httpUrl + '/appr/getDataForCertificate' + obj ).toPromise().then(res => {
      return res;
    });
    return res;
  }



async getundertakings(obj:any){
  const res = await this.http.get<any>(this.main.httpUrl + '/administration/undertakings/undertakingsbyRoleDoc' + obj ).toPromise().then(res => {
    return res;
  });
  return res;
}

  async getPendingApprbydoclocalno(obj:any){
    const resp = await this.http.get<any>(this.main.httpUrl + '/appr/getPendingApprbydoclocalno'+obj ).toPromise().then(res => {
      return res;
    });
    return resp;
  }

  async rejectAppr(obj:any){
    const resp = await this.http.post<any>(this.main.httpUrl + '/appr/rejectAppr', obj ).toPromise().then(res => {
      return res;
    });
    return resp;
  }

  async getWorkTenderId(obj:any){
    const res = await this.http.get<any>(this.main.httpUrl + '/appr/getWorkTenderId' + obj ).toPromise().then(res => {
      return res;
    });
    return res;
  }

  async getDocInfo(obj:any){
    const res = await this.http.get<any>(this.main.httpUrl + '/info/upload/getDocInfo' + obj ).toPromise().then(res => {
      return res;
    });
    return res;
  }

  async viewDoc(obj:any){

    const resp = await this.http.post(this.main.httpUrl + '/info/upload/viewDoc', obj,  {   responseType: 'blob' }).toPromise().then(res => {
      return res;
    });
    //oc
  //   if (resp) {
  //     return resp;
  // }
  //ec
      return resp;
}
  // async viewDoc(obj:any){
  //   const res = await this.http.post<any>(this.main.httpUrl + '/info/upload/viewDoc' , obj, { responseType: 'blob' }).toPromise().then(res => {
  //     return res;
  //   });
  //   return res;
  // }

  async getWorkInfo(obj:any){
    const res = await this.http.get<any>(this.main.httpUrl + '/info/work/getWorkFromTender' + obj ).toPromise().then(res => {
      return res;
    });
    return res;
  }

  async insertForAppr(obj:any){
    const resp = await this.http.post<any>(this.main.httpUrl + '/appr/insertForAppr', obj ).toPromise().then(res => {
      return res;
    });
    return resp;
  }
  async updateappr(obj:any){
    const resp = await this.http.put<any>(this.main.httpUrl + '/appr/updateappr', obj ).toPromise().then(res => {
      return res;
    });
    return resp;
  }
  async getApprbyuserid(obj:any){
    const resp = await this.http.get<any>(this.main.httpUrl + '/appr/getApprbyuserid'+obj ).toPromise().then(res => {
      return res;
    });
    return resp;
  }
  async getApprbydoclocalno(obj:any){
    const resp = await this.http.get<any>(this.main.httpUrl + '/appr/getApprbydoclocalno'+obj ).toPromise().then(res => {
      return res;
    });
    return resp;
  }

  async getApprovalHier(obj:any){
    const resp = await this.http.get<any>(this.main.httpUrl + '/approve/getApprovalHier' + obj ).toPromise().then(res => {
      return res;
    });
    return resp;
  }
  async getApprovalStatus(obj:any){
    const resp = await this.http.get<any>(this.main.httpUrl + '/approve/getApprovalStatus' + obj ).toPromise().then(res => {
      return res;
    });
    return resp;
  }

  async approveTask(obj:any){
    const resp = await this.http.put<any>(this.main.httpUrl + '/approve/approveTask', obj ).toPromise().then(res => {
      return res;
    });
    return resp;
  }
  async rejectTask(obj:any){
    const resp = await this.http.put<any>(this.main.httpUrl + '/approve/rejectTask', obj ).toPromise().then(res => {
      return res;
    });
    return resp;
  }

  async insertForApproval(obj:any){
    const resp = await this.http.post<any>(this.main.httpUrl + '/approve/insertForApproval', obj ).toPromise().then(res => {
      return res;
    });
    return resp;
  }

  async getStatus(obj:any){
    const resp = await this.http.get<any>(this.main.httpUrl + '/approve/getStatus'+obj ).toPromise().then(res => {
      return res;
    });
    return resp;
  }

  async changestatusINTENDER(obj:any){
    const resp = await this.http.put<any>(this.main.httpUrl + '/info/boq/changestatus', obj ).toPromise().then(res => {
      return res;
    });
    return resp;
  }
  async changestatusINEMB(obj:any){
    const resp = await this.http.put<any>(this.main.httpUrl + '/info/emb/changestatus', obj ).toPromise().then(res => {
      return res;
    });
    return resp;
  }
  async getWorkBudInfo(obj:any){
    const resp = await this.http.get<any>(this.main.httpUrl + '/info/ebill/getWorkBudInfo'+ obj ).toPromise().then(res => {
      return res;
    });
    return resp;

  }
  async changestatusINEBILL(obj:any){
    const resp = await this.http.put<any>(this.main.httpUrl + '/info/ebill/updateebillstatus', obj ).toPromise().then(res => {
      return res;
    });
    return resp;
  }
}
